import auth0 from '.'
import { getInitialScreen, getSignInUrl } from '../errors'

export default async function requestNewLink(code: string): Promise<void> {
  try {
    const initialScreen = getInitialScreen(code)
    await auth0().loginWithRedirect({
      authorizationParams: {
        initialScreen,
        redirect_uri: `${window.location.origin}/sso/browse/callback`,
      },
    })
  } catch (_error) {
    const signInUrl = getSignInUrl()
    window.location.replace(signInUrl)
  }
}
